import request from "lib/request"
import swal from "sweetalert2"
import { showError, showSuccess } from "../../../components/common"

export const CURRENT_USER_REQUEST         = 'CURRENT_USER_REQUEST'
export const CURRENT_USER_REQUEST_ERROR   = 'CURRENT_USER_REQUEST_ERROR'
export const CURRENT_USER_REQUEST_SUCCESS = 'CURRENT_USER_REQUEST_SUCCESS'
export const CURRENT_USER_FETCHING        = 'CURRENT_USER_FETCHING'

export const LOCK         = 'LOCK'
export const LOCK_ERROR   = 'LOCK_ERROR'
export const LOCK_SUCCESS = 'LOCK_SUCCESS'
export const IS_LOCKING   = 'IS_LOCKING'

export const SEND_OTP         = 'SEND_OTP'
export const SEND_OTP_ERROR   = 'SEND_OTP_ERROR'
export const SEND_OTP_SUCCESS = 'SEND_OTP_SUCCESS'
export const IS_SENDING_OTP   = 'IS_SENDING_OTP'

export const LOCK_HISTORY_REQUEST         = 'LOCK_HISTORY_REQUEST'
export const LOCK_HISTORY_REQUEST_ERROR   = 'LOCK_HISTORY_REQUEST_ERROR'
export const LOCK_HISTORY_REQUEST_SUCCESS = 'LOCK_HISTORY_REQUEST_SUCCESS'
export const LOCK_HISTORY_FETCHING        = 'LOCK_HISTORY_FETCHING'

// USER
export const isCurrentUserFetching = () => {
  return {
    type: CURRENT_USER_FETCHING
  }
}

export const getCurrentUser = (callback = () => {}) => {
  return (dispatch, getState) => {
    dispatch(isCurrentUserFetching());
    request('api/user/get').then(function (response) {
      if (response.status == 'successful') {
        dispatch(getCurrentUserSuccess(response));
        callback();
        setTimeout(() => {
          window.location.href = '/user/logout';
        }, 600000);
        if (response.payload.user_status.ban_status) {
          showSuccess('already_locked', 'Thông báo', () => {
            window.location.href = '/user/logout';
          });

          setTimeout(() => {
            window.location.href = '/user/logout';
          }, 10000);
        }

        if (!response.payload.user.account_id) {
          swal({
            title: 'Thông báo',
            html: '<p class="pop-content">Bạn chưa tạo HLV, vui lòng tạo HLV rồi quay lại.</p>',
            animation: false,
            confirmButtonText: 'Đóng',
            customClass: 'custom-modal animated zoomIn'
          }).then((result) => {
            window.location.href = "/user/logout"
          })
        }
      } else {
        dispatch(getCurrentUserError(response))
        if (response.error_code == 'error_account_not_found') {
          swal({
            title: 'Thông báo',
            html: '<p class="pop-content">Bạn chưa tạo HLV, vui lòng tạo HLV rồi quay lại.</p>',
            animation: false,
            confirmButtonText: 'Đóng',
            customClass: 'custom-modal animated zoomIn'
          }).then((result) => {
            window.location.href = "/user/logout"
          })
        }
      }
    })
  }
}

export const getCurrentUserSuccess = (response) => {
  return {
    type: CURRENT_USER_REQUEST_SUCCESS,
    payload: response.payload
  }
}

export const getCurrentUserError = (response) => {
  return {
    type: CURRENT_USER_REQUEST_ERROR,
    payload: response
  }
}

// LOCK ACCOUNT
export const isLocking = () => {
  return {
    type: IS_LOCKING
  }
}

export const lockAccount = ({name, otp}, callback) => {
  return (dispatch, getState) => {
    dispatch(isLocking());
    request('api/user/lock_account', 'POST', {
      body: JSON.stringify({ name, otp })
    }).then(function(response) {
      if (response.status == 'successful') {
        callback();
        showSuccess('lock_account_success', 'Thông báo', () => {
          window.location.href = '/user/logout';
        });

        dispatch(lockSuccess(response));

        setTimeout(() => {
          window.location.href = '/user/logout';
        }, 10000);
      } else {
        showError(response.error_code, 'Lỗi', {
          message: response.message
        });
        dispatch(lockError(response));
      }
    })
  }
}

export const lockSuccess = (response) => {
  return {
    type: LOCK_SUCCESS,
    payload: response
  }
}

export const lockError = (response) => {
  return {
    type: LOCK_ERROR,
    payload: response
  }
}

// SEND OTP
export const isSendingOtp = () => {
  return {
    type: IS_SENDING_OTP
  }
}

export const sendOtp = (callback = () => {}) => {
  return (dispatch, getState) => {
    dispatch(isSendingOtp());
    request('api/user/send_otp').then(function(response) {
      if (response.status == 'successful') {
        showSuccess('send_otp_success');
        dispatch(sendOtpSuccess(response));
        callback();
      } else {
        showError(response.error_code);
        dispatch(sendOtpError(response));
      }
    })
  }
}

export const sendOtpSuccess = (response) => {
  return {
    type: SEND_OTP_SUCCESS,
    payload: response
  }
}

export const sendOtpError = (response) => {
  return {
    type: SEND_OTP_ERROR,
    payload: response
  }
}

// LOCK HISTORY
export const isLockHistoryFetching = () => {
  return {
    type: LOCK_HISTORY_FETCHING
  }
}

export const getLockHistory = () => {
  return (dispatch, getState) => {
    dispatch(isLockHistoryFetching());
    request('api/user/get_lock_history').then(function(response) {
      if (response.status == 'successful') {
        dispatch(getLockHistorySuccess(response));
      } else {
        showError(response.error_code);
        dispatch(getLockHistoryError(response))
      }
    })
  }
}

export const getLockHistorySuccess = (response) => {
  return {
    type: LOCK_HISTORY_REQUEST_SUCCESS,
    payload: response.payload
  }
}

export const getLockHistoryError = (response) => {
  return {
    type: LOCK_HISTORY_REQUEST_ERROR,
    payload: response
  }
}



// WEBPACK FOOTER //
// ./src/routes/Home/modules/actions.js